import moment, { unitOfTime } from 'moment';
import { IsoString } from 'models';

export enum ISurveyDurationTypes {
	HALF_A_YEAR = 'HALF_A_YEAR',
	ONE_YEAR = 'ONE_YEAR',
	TWO_YEARS = 'TWO_YEARS',
	THREE_YEARS = 'THREE_YEARS',
	FOUR_YEARS = 'FOUR_YEARS',
}

export const SurveyDurationValues = {
	[ISurveyDurationTypes.HALF_A_YEAR]: (data?: IsoString) =>
		getDurationPeriodValue(6, 'month', data),
	[ISurveyDurationTypes.ONE_YEAR]: (data?: IsoString) =>
		getDurationPeriodValue(1, 'year', data),
	[ISurveyDurationTypes.TWO_YEARS]: (data?: IsoString) =>
		getDurationPeriodValue(2, 'year', data),
	[ISurveyDurationTypes.THREE_YEARS]: (data?: IsoString) =>
		getDurationPeriodValue(3, 'year', data),
	[ISurveyDurationTypes.FOUR_YEARS]: (data?: IsoString) =>
		getDurationPeriodValue(4, 'year', data),
};

function getDurationPeriodValue(count: number, unit: string, data?: IsoString) {
	return moment(data)
		.add(count, unit as unitOfTime.Base)
		.add(1, 'day');
}
